import React, { Component } from 'react'
import VULogoAllBlackDiamond from '../../static/img/logos/vu_logo_melb_black_diamond.svg'
import { getStepIndexByUrl } from '../../helpers/steps'
import { withRouter } from 'react-router-dom'
import { Toolbar, IconButton, Box, Tooltip } from '@mui/material'
import { ArrowLeft, ExitToApp, HelpOutline } from '@mui/icons-material'

class Header extends Component {
  constructor(props) {
    super(props)
  }

  navigateBack = () => {
    window.history.back()
  }

  componentDidMount() {}

  getCurrentStepIndex = () => getStepIndexByUrl(this.props.location.pathname)

  isHomePage = () => this.getCurrentStepIndex() === 0

  handleLogoutClick = event => {
    event.preventDefault()

    const confirmation = confirm(
      'Are you sure you want to exit your enrolment?'
    )
    if (confirmation) {
      localStorage.clear()
      sessionStorage.clear()

      window.location.assign('/api/logout/enrol')
    }
  }

  render() {
    return (
      <div>
        <Toolbar className="header">
          {/*<ToolbarGroup firstChild className="header-group" style={{visibility: this.isHomePage() ? 'hidden': 'visible'}}>*/}
          <Box className="header-group">
            
            <IconButton
              className="btn-back"
              onClick={this.navigateBack}
            >
              <ArrowLeft />
            </IconButton>
          </Box>
          <div className="logo-container">
            <img
              className="vu-logo"
              alt="Victoria University logo"
              src={VULogoAllBlackDiamond}
            />
          </div>
          <Box className="header-group">
            <Tooltip title="Help">
              <IconButton
                className="btn-chat"
                onClick={this.props.onHamburgerClick}
              >
                <HelpOutline />
              </IconButton>
            </Tooltip>
            <Tooltip title="Log out">
              <IconButton
                className="log-out"
                onClick={this.handleLogoutClick}
              >
                <ExitToApp />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </div>
    )
  }
}

export default withRouter(Header)
